import { lazy } from "react";
import { carSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import( /* webpackChunkName: "dealers" */ './components/EntryPoint'));
const DealersLoader = lazy(() => import( /* webpackChunkName: "dealersLoader" */ './components/DealersLoader'));
const DealerForm = lazy(() => import( /* webpackChunkName: "dealerForm" */ './components/DealerForm'));

export const defaultPath = '/dealers';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: DealersLoader,
        exact: true,
        icon: carSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'dealer_list',
            plural: false
        }
    },
    {
        path: `${defaultPath}/new`,
        Component: DealerForm,
        exact: true,
        icon: carSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'create_new_dealer',
            plural: false
        }
    },
    {
        path: `${defaultPath}/:id`,
        Component: DealerForm,
        exact: true,
        icon: carSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'modify_dealer',
            plural: false
        }
    }
];

const Dealers = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: carSVG,
    title: {
        key: 'dealers',
        plural: false
    },
    subTitle: {
        key: 'dealer_list',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Dealers;
